import type { CustomField } from '../types';

// The server rejects a field without a label and a dropdown without options.
export const isCustomFieldIncomplete = (field: CustomField): boolean => {
  if (!field.label.custom.trim()) {
    return true;
  }
  return field.type === 'dropdown' && !field.dropdown?.options.length;
};

export const countIncompleteCustomFields = (fields: CustomField[] = []): number => {
  return fields.filter(isCustomFieldIncomplete).length;
};
